export default function($) {
  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    if($('.js-nav-items').hasClass('nav-items-active')) {
      $('.nav-items').removeClass('nav-items-active');
      $(this).find('svg').css('fill', '#1D1B1B');
      $('body').css('max-height', 'none');
      $('body').css('overflow', 'initial');
      $(this).removeClass('nav-trigger-active');
    } else {
      $('.nav-items').addClass('nav-items-active');
      $(this).find('svg').css('fill', '#D42D26');
      $('body').css('max-height', '100%');
      $('body').css('overflow', 'hidden');
      $(this).addClass('nav-trigger-active');
    }
  });

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav, .js-nav-mobile-button').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
      if($('.js-nav-items').hasClass('nav-items-active')) {
        $('.nav-items').removeClass('nav-items-active');
        $('.js-nav-mobile-button').find('svg').css('fill', '#1D1B1B');
        $('body').css('max-height', 'none');
        $('body').css('overflow', 'initial');
        $('.js-nav-mobile-button').removeClass('nav-trigger-active');
      }
    }
  });

  $(window).resize(function() {
    if( $(window).width() >= 1024 ) {
      $('.js-nav-items').css('display', 'flex');
    } else {
      $('.nav-items').removeClass('nav-items-active');
      $('.js-nav-mobile-button').find('svg').css('fill', '#1D1B1B');
      $('body').css('max-height', 'none');
      $('body').css('overflow', 'initial');
      $('.js-nav-mobile-button').removeClass('nav-trigger-active');
    }
  })

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });


  // Product cat nav on mobile

  var productNav = $('.js-woocommerce-nav-items'),
      openProductNav = $('.js-woocommerce-nav-trigger'),
      closeProductNav = $('.js-woocommerce-nav-close');

  openProductNav.on('click', function() {
    if( !productNav.hasClass('open') ) {
      productNav.addClass('open');
      openProductNav.find('svg').css('fill', '#D42D26');
      $('body').css('max-height', '100%');
      $('body').css('overflow', 'hidden');
    }
  });

  closeProductNav.on('click', function() {
    if( productNav.hasClass('open') ) {
      productNav.removeClass('open');
      openProductNav.find('svg').css('fill', '#1D1B1B');
      $('body').css('max-height', 'none');
      $('body').css('overflow', 'initial');
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.woocommerce-nav').length) {
      if (productNav.hasClass("open")) {
        productNav.removeClass('open');
        openProductNav.find('svg').css('fill', '#1D1B1B');
        $('body').css('max-height', 'none');
        $('body').css('overflow', 'initial');
      }
    }
  });
}
